import { render, staticRenderFns } from "./modalVisualizarEdital.vue?vue&type=template&id=a98ad0e6&scoped=true&lang=pug&"
import script from "./modalVisualizarEdital.vue?vue&type=script&lang=js&"
export * from "./modalVisualizarEdital.vue?vue&type=script&lang=js&"
import style0 from "./modalVisualizarEdital.vue?vue&type=style&index=0&id=a98ad0e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a98ad0e6",
  null
  
)

export default component.exports